import { useContext, useEffect, useState } from 'react';
import { NotificationsContext } from '../../../common/notifications/Notifications';
import { Flexbox } from '@hiiretail/synergy-ui';
import { CreateButton } from '../../../common/components/Breadcrumbs/buttons/CreateButton/CreateButton';
import { useBreadcrumbsActions } from '../../../common/components/Breadcrumbs/context/useBreadcrumbsActions';
import { useQueryClient } from 'react-query';

type UseEditGroupDetailsModalFacade = (groupId: string) => {
  isEditGroupDetailsModalOpen: boolean;
  closeEditGroupDetailsModal: () => void;
  onGroupEditionSuccess: () => void;
};

export const useEditGroupDetailsModalFacade: UseEditGroupDetailsModalFacade = (groupId) => {
  const [isEditGroupDetailsModalOpen, setIsEditGroupDetailsModalOpen] = useState(false);

  const { showNotification } = useContext(NotificationsContext);
  const { updateActions } = useBreadcrumbsActions();
  const queryClient = useQueryClient();

  const openEditGroupDetailsModal = () => setIsEditGroupDetailsModalOpen(true);

  const closeEditGroupDetailsModal = () => setIsEditGroupDetailsModalOpen(false);

  const onGroupEditionSuccess = () => {
    queryClient.invalidateQueries([`group-${groupId}`]).then();
    queryClient.invalidateQueries(`groups`);
    showNotification('Group successfully updated!');
    closeEditGroupDetailsModal();
  };

  useEffect(() => {
    updateActions(
      <>
        <Flexbox item>
          <CreateButton
            title="Edit"
            onClick={openEditGroupDetailsModal}
            permission="iam.group.update"
          />
        </Flexbox>
      </>,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    isEditGroupDetailsModalOpen,
    closeEditGroupDetailsModal,
    onGroupEditionSuccess,
  };
};
